<template>
  <div class="modal">
    <div class="modal-wrapper">
      <div class="modal-container">
        <div class="modal-header">
          <p class="modal-title" v-if="title">{{ title }}</p>
        </div>
        <div class="modal-content wysiwyg">
          <p v-if="content">{{ content }}</p>
        </div>
        <div class="form-group" v-if="checkbox">
          <div class="checkbox">
            <label>
              <input type="checkbox" v-model="checkboxValue">
              {{ checkbox }}
            </label>
          </div>
        </div>
        <div class="modal-footer">
          <slot name="footer">
            <button type="button" class="modal-button-cancel" @click="onCancel">
              {{ Translator('front.cart.modal.cancel') }}
            </button>
            <button type="button" class="modal-button" @click="onConfirm">
              {{ Translator('front.cart.modal.confirm') }}
            </button>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ModalService from '@/services/Modal';
export default {
  name: 'modal',
  data () {
    return {
      title: null,
      content: null,
      checkbox: null,
      checkboxValue: false
    }
  },
  mounted() {
    const datas = ModalService.datas;
    if(datas.title) this.title = datas.title;
    if(datas.content) this.content = datas.content;
    if(datas.checkbox) this.checkbox = datas.checkbox;
  },
  methods: {
    onCancel() {
      ModalService.cancel();
    },

    onConfirm() {
      if(this.checkbox) {
        ModalService.confirm({ disableConfirmation: this.checkboxValue });
      } else ModalService.confirm();
    },

    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    },
  }
}
</script>
<style scoped lang="scss">
.modal {
  position: fixed;
  z-index: 20;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba($black, 0.2);
  transition: opacity 0.3s ease;
  .modal-wrapper {
    @include container;
    position: absolute;
    width: 90vw;
    max-width: rem(600);
    padding: rem(40);
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
  }
  .modal-container {
  }
  .modal-title {
    @include title(4);
  }
  .modal-content {}
  .modal-footer {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: rem(20);
  }
  .modal-button-cancel {
    @include cta($color-main, $white);
    margin-left: rem(10);
    margin-right: rem(10);
  }
  .modal-button {
    @include cta;
    margin-left: rem(10);
    margin-right: rem(10);
  }
}
</style>